import script from "./ShoppingCartProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingCartProduct.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingCartProduct.vue?vue&type=style&index=0&id=132e3d54&lang=scss"

const __exports__ = script;

export default __exports__